function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/*********************************************************************************

 NFT CRYPTO MODULE

 Treats a single NFT (by nft_id) as a CryptoModule so it can be:
  - displayed in the wallet
  - selected as a payment asset
  - transferred fractionally
  - staked / wagered by games

 One instance == one NFT id (aggregates all owned slips)

**********************************************************************************/

var CryptoModule = require('./cryptomodule');
var SaitoNFT = require('../saito/ui/saito-nft/saito-nft');

// Mirror saito-js enums so this file loads without bundler resolution (TransactionType.Bound = 8, SlipType.Bound = 9).
var TX_TYPE_BOUND = 8;
var SLIP_BOUND = 9;
var SLIP_NORMAL = 0;
var SLIP_ATR = 1;

/**
 * Bound NFT input triple: slip[i] and slip[i+2] are Bound; slip[i+1] is Normal or ATR.
 * Matches rust `Transaction::is_nft`.
 */
function isNftInputTriple(slips, i) {
  if (!slips || i + 2 >= slips.length) {
    return false;
  }
  var a = slips[i];
  var b = slips[i + 1];
  var c = slips[i + 2];
  return (a === null || a === void 0 ? void 0 : a.type) === SLIP_BOUND && (c === null || c === void 0 ? void 0 : c.type) === SLIP_BOUND && ((b === null || b === void 0 ? void 0 : b.type) === SLIP_NORMAL || (b === null || b === void 0 ? void 0 : b.type) === SLIP_ATR);
}
var NFTCryptoModule = /*#__PURE__*/function (_CryptoModule) {
  function NFTCryptoModule(app, nft_id) {
    var _this;
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, NFTCryptoModule);
    // ticker must be unique per NFT
    var ticker = opts.ticker || "NFT-".concat(app.crypto.hash(nft_id).slice(0, 6));
    _this = _callSuper(this, NFTCryptoModule, [app, ticker]);
    _this.name = opts.name || ticker;
    _this.description = opts.description || 'NFT Asset';
    _this.categories = 'NFT';

    // NFT identity
    _this.nft_id = nft_id;

    // Optional explicit image (e.g. injected when mint tx is already loaded)
    _this._nft_logo_opt = typeof opts.image === 'string' && opts.image.trim() ? opts.image.trim() : '';

    //
    // Cached logos for header / crypto UI: thumb keeps memory and decode cost down
    //
    _this._nft_logo_thumb = null;
    _this._nft_logo_full = null;
    _this._nft_logo_refresh_promise = null;

    // NFTs are local UTXO assets
    _this.confirmations = 0;
    _this.warning = '';
    _this.introduction = '';

    // NFTs do not have external addresses
    _this.address = _this.app.wallet.publicKey;

    // It is easier to flag native cryptos than web3 (especially if we add some outside mixin)
    // Also applies to ghost Saito module in wallet.ts
    _this.chain_id = 'NATIVE';

    // History is intentionally unsupported
    _this.history = null;
    _this.history_update_ts = 0;

    // Mark as activated immediately
    _this.options.isActivated = true;
    return _this;
  }

  /**
   * Load balance/options from disk, then resolve NFT artwork for returnLogos().
   */
  _inherits(NFTCryptoModule, _CryptoModule);
  return _createClass(NFTCryptoModule, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(NFTCryptoModule, "initialize", this, 3)([app]);
            case 1:
              this.refreshNFTLogoCache()["catch"](function (err) {
                console.warn('NFTCryptoModule: refreshNFTLogoCache failed', (err === null || err === void 0 ? void 0 : err.message) || err);
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var row;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(NFTCryptoModule, "activate", this, 3)([]);
            case 1:
              if (this.nft) {
                _context2.n = 4;
                break;
              }
              _context2.n = 2;
              return this.app.wallet.updateNFTList();
            case 2:
              row = this._returnSampleWalletNFT();
              if (!(!row || !row.id)) {
                _context2.n = 3;
                break;
              }
              throw new Error('NFTCryptoModule: NFT not found in wallet');
            case 3:
              this.nft = new SaitoNFT(this.app, null, null, row);
              _context2.n = 4;
              return this.nft.fetchTransaction();
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     * Best-effort: pull image from wallet row, mint tx (via SaitoNFT), optional downscale for UI.
     * Safe to call repeatedly; concurrent calls share one in-flight refresh.
     */
  }, {
    key: "refreshNFTLogoCache",
    value: function () {
      var _refreshNFTLogoCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this._nft_logo_refresh_promise) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, this._nft_logo_refresh_promise);
            case 1:
              this._nft_logo_refresh_promise = this._refreshNFTLogoCacheBody()["finally"](function () {
                _this2._nft_logo_refresh_promise = null;
              });
              return _context3.a(2, this._nft_logo_refresh_promise);
          }
        }, _callee3, this);
      }));
      function refreshNFTLogoCache() {
        return _refreshNFTLogoCache.apply(this, arguments);
      }
      return refreshNFTLogoCache;
    }()
  }, {
    key: "_refreshNFTLogoCacheBody",
    value: function () {
      var _refreshNFTLogoCacheBody2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var prevThumb, prevFull, full, row, _this$app, _this$app2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              prevThumb = this._nft_logo_thumb;
              prevFull = this._nft_logo_full;
              full = this._nft_logo_opt || '';
              if (!full) {
                full = this._inlineImageFromWalletRow(this._returnSampleWalletNFT());
              }
              if (full) {
                _context4.n = 2;
                break;
              }
              row = this._returnSampleWalletNFT();
              if (!row) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this._fetchNftMintImageFromArchive(row);
            case 1:
              full = _context4.v;
            case 2:
              if (full) {
                _context4.n = 3;
                break;
              }
              this._nft_logo_thumb = null;
              this._nft_logo_full = null;
              if ((prevThumb || prevFull) && (_this$app = this.app) !== null && _this$app !== void 0 && _this$app.connection) {
                // This does nothing
                this.app.connection.emit('saito-header-update-crypto');
              }
              return _context4.a(2);
            case 3:
              this._nft_logo_full = full;
              _context4.n = 4;
              return this._maybeDownscaleLogoForCache(full);
            case 4:
              this._nft_logo_thumb = _context4.v;
              if (prevThumb !== this._nft_logo_thumb || prevFull !== this._nft_logo_full) {
                if ((_this$app2 = this.app) !== null && _this$app2 !== void 0 && _this$app2.connection) {
                  // This does nothing
                  this.app.connection.emit('saito-header-update-crypto');
                }
              }
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function _refreshNFTLogoCacheBody() {
        return _refreshNFTLogoCacheBody2.apply(this, arguments);
      }
      return _refreshNFTLogoCacheBody;
    }()
  }, {
    key: "_returnSampleWalletNFT",
    value: function _returnSampleWalletNFT() {
      var _this$app3,
        _this3 = this;
      var list = (_this$app3 = this.app) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.options) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.wallet) === null || _this$app3 === void 0 ? void 0 : _this$app3.nfts;
      if (!Array.isArray(list)) {
        return null;
      }
      return list.find(function (n) {
        return n && n.id === _this3.nft_id;
      }) || null;
    }

    /**
     * Read mint tx from local archive (same search strategy as SaitoNFT) and return data.image.
     * Uses a sync load callback so await storage.loadTransactions sees the parsed result.
     */
  }, {
    key: "_fetchNftMintImageFromArchive",
    value: function () {
      var _fetchNftMintImageFromArchive2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _this$app4,
          _this4 = this;
        var pickImage, load, cond1, im;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(!(row !== null && row !== void 0 && row.id) || !((_this$app4 = this.app) !== null && _this$app4 !== void 0 && (_this$app4 = _this$app4.storage) !== null && _this$app4 !== void 0 && _this$app4.loadTransactions))) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, '');
            case 1:
              pickImage = function pickImage(txs) {
                if (!(txs !== null && txs !== void 0 && txs.length)) {
                  return '';
                }
                try {
                  var _txmsg$data;
                  var txmsg = txs[0].returnMessage();
                  var _im = txmsg === null || txmsg === void 0 || (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.image;
                  return typeof _im === 'string' && _im.trim() ? _im.trim() : '';
                } catch (err) {
                  return '';
                }
              };
              load = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(cond) {
                  var out, _t;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.p = _context5.n) {
                      case 0:
                        _context5.p = 0;
                        _context5.n = 1;
                        return _this4.app.storage.loadTransactions(cond, function (txs) {
                          return pickImage(txs);
                        }, 'localhost');
                      case 1:
                        out = _context5.v;
                        return _context5.a(2, typeof out === 'string' && out ? out : '');
                      case 2:
                        _context5.p = 2;
                        _t = _context5.v;
                        return _context5.a(2, '');
                    }
                  }, _callee5, null, [[0, 2]]);
                }));
                return function load(_x3) {
                  return _ref.apply(this, arguments);
                };
              }();
              cond1 = row.tx_sig ? {
                sig: row.tx_sig
              } : {
                field4: row.id
              };
              _context6.n = 2;
              return load(cond1);
            case 2:
              im = _context6.v;
              if (!im) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2, im);
            case 3:
              if (!row.tx_sig) {
                _context6.n = 5;
                break;
              }
              _context6.n = 4;
              return load({
                field4: row.id
              });
            case 4:
              im = _context6.v;
            case 5:
              return _context6.a(2, im || '');
          }
        }, _callee6, this);
      }));
      function _fetchNftMintImageFromArchive(_x2) {
        return _fetchNftMintImageFromArchive2.apply(this, arguments);
      }
      return _fetchNftMintImageFromArchive;
    }()
  }, {
    key: "_inlineImageFromWalletRow",
    value: function _inlineImageFromWalletRow(row) {
      var _row$txmsg;
      if (!row || _typeof(row) !== 'object') {
        return '';
      }
      if (typeof row.image === 'string' && row.image.trim()) {
        return row.image.trim();
      }
      if (row.data && typeof row.data.image === 'string' && row.data.image.trim()) {
        return row.data.image.trim();
      }
      if ((_row$txmsg = row.txmsg) !== null && _row$txmsg !== void 0 && _row$txmsg.data && typeof row.txmsg.data.image === 'string' && row.txmsg.data.image.trim()) {
        return row.txmsg.data.image.trim();
      }
      return '';
    }

    /**
     * For large raster data URLs, draw to a small canvas and keep a JPEG in memory for the header.
     * Skips http(s) sources (canvas taint) and small payloads.
     */
  }, {
    key: "_maybeDownscaleLogoForCache",
    value: function _maybeDownscaleLogoForCache(src) {
      var _this5 = this;
      return new Promise(function (resolve) {
        var _this5$app;
        if (!src || typeof src !== 'string') {
          resolve(src);
          return;
        }
        if (!((_this5$app = _this5.app) !== null && _this5$app !== void 0 && _this5$app.BROWSER) || typeof document === 'undefined' || typeof Image === 'undefined') {
          resolve(src);
          return;
        }
        var lower = src.slice(0, 11).toLowerCase();
        if (!lower.startsWith('data:image')) {
          resolve(src);
          return;
        }
        var maxBytes = 48 * 1024;
        if (src.length <= maxBytes) {
          resolve(src);
          return;
        }
        var img = new Image();
        var done = function done(out) {
          return resolve(out || src);
        };
        img.onload = function () {
          try {
            var maxDim = 144;
            var w = img.naturalWidth || img.width;
            var h = img.naturalHeight || img.height;
            if (!w || !h) {
              done(src);
              return;
            }
            var scale = Math.min(1, maxDim / Math.max(w, h));
            var tw = Math.max(1, Math.round(w * scale));
            var th = Math.max(1, Math.round(h * scale));
            var canvas = document.createElement('canvas');
            canvas.width = tw;
            canvas.height = th;
            var ctx = canvas.getContext('2d');
            if (!ctx) {
              done(src);
              return;
            }
            ctx.drawImage(img, 0, 0, tw, th);
            var jpeg = canvas.toDataURL('image/jpeg', 0.72);
            done(jpeg && jpeg.length < src.length ? jpeg : src);
          } catch (err) {
            done(src);
          }
        };
        img.onerror = function () {
          return done(src);
        };
        img.src = src;
      });
    }
  }, {
    key: "returnLogos",
    value: function returnLogos() {
      var _this$app5;
      var img = this._nft_logo_thumb || this._nft_logo_full;
      if (img) {
        return {
          img: img,
          alt_img: this._nft_logo_full || img
        };
      }
      if ((_this$app5 = this.app) !== null && _this$app5 !== void 0 && _this$app5.BROWSER) {
        this.refreshNFTLogoCache()["catch"](function () {});
      }
      return _superPropGet(NFTCryptoModule, "returnLogos", this, 3)([]);
    }

    /********************************************************
     * REQUIRED CRYPTOMODULE INTERFACE
     ********************************************************/

    /**
     * Internal helper to collect NFT slips from wallet options
     */
  }, {
    key: "_returnNFTSlips",
    value: function _returnNFTSlips() {
      var _this$app6,
        _this6 = this;
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _opts$unreserved = opts.unreserved,
        unreserved = _opts$unreserved === void 0 ? false : _opts$unreserved,
        _opts$state = opts.state,
        state = _opts$state === void 0 ? 'unspent' : _opts$state,
        _opts$limit = opts.limit,
        limit = _opts$limit === void 0 ? null : _opts$limit;
      if (!((_this$app6 = this.app) !== null && _this$app6 !== void 0 && (_this$app6 = _this$app6.options) !== null && _this$app6 !== void 0 && (_this$app6 = _this$app6.wallet) !== null && _this$app6 !== void 0 && _this$app6.nfts)) {
        return [];
      }
      var slips = this.app.options.wallet.nfts.filter(function (n) {
        return n.id === _this6.nft_id;
      });
      if (unreserved) {
        slips = slips.filter(function (s) {
          return !s.reserved;
        });
      }
      if (state === 'unspent') {
        slips = slips.filter(function (s) {
          return !s.spent;
        });
      }
      if (limit) {
        slips = slips.slice(0, limit);
      }
      return slips;
    }
  }, {
    key: "getAvailableBalance",
    value: function () {
      var _getAvailableBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.fetchBalance();
            case 1:
              return _context7.a(2, _context7.v);
          }
        }, _callee7, this);
      }));
      function getAvailableBalance() {
        return _getAvailableBalance.apply(this, arguments);
      }
      return getAvailableBalance;
    }()
  }, {
    key: "getPendingBalance",
    value: function () {
      var _getPendingBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var confirmedStr, confirmed, outgoing, txs, myPk, _iterator, _step, tx, from, i, tripleId, raw, pending, _t2, _t3;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.n = 1;
              return this.fetchBalance();
            case 1:
              confirmedStr = _context8.v;
              confirmed = 0n;
              try {
                confirmed = BigInt(String(confirmedStr || '0'));
              } catch (e) {
                confirmed = 0n;
              }
              outgoing = 0n;
              _context8.p = 2;
              _context8.n = 3;
              return this.app.wallet.getPendingTxs();
            case 3:
              txs = _context8.v;
              myPk = this.app.wallet.publicKey;
              _iterator = _createForOfIteratorHelper(txs);
              _context8.p = 4;
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context8.n = 12;
                break;
              }
              tx = _step.value;
              if (!(tx.type !== TX_TYPE_BOUND)) {
                _context8.n = 6;
                break;
              }
              return _context8.a(3, 11);
            case 6:
              if (!(typeof tx.isFrom === 'function' && !tx.isFrom(myPk))) {
                _context8.n = 7;
                break;
              }
              return _context8.a(3, 11);
            case 7:
              from = tx.from || [];
              i = 0;
            case 8:
              if (!(i + 2 < from.length)) {
                _context8.n = 11;
                break;
              }
              if (isNftInputTriple(from, i)) {
                _context8.n = 9;
                break;
              }
              i++;
              return _context8.a(3, 10);
            case 9:
              tripleId = this.app.wallet.computeNFTIdFromTx({
                to: [from[i], from[i + 1], from[i + 2]],
                from: []
              });
              if (tripleId === this.nft_id) {
                try {
                  raw = from[i].amount;
                  outgoing += BigInt(typeof raw === 'bigint' ? raw : String(raw));
                } catch (e) {}
              }
              i += 3;
            case 10:
              _context8.n = 8;
              break;
            case 11:
              _context8.n = 5;
              break;
            case 12:
              _context8.n = 14;
              break;
            case 13:
              _context8.p = 13;
              _t2 = _context8.v;
              _iterator.e(_t2);
            case 14:
              _context8.p = 14;
              _iterator.f();
              return _context8.f(14);
            case 15:
              _context8.n = 17;
              break;
            case 16:
              _context8.p = 16;
              _t3 = _context8.v;
              console.warn('NFTCryptoModule getPendingBalance:', _t3);
            case 17:
              pending = confirmed >= outgoing ? confirmed - outgoing : 0n;
              return _context8.a(2, pending.toString());
          }
        }, _callee8, this, [[4, 13, 14, 15], [2, 16]]);
      }));
      function getPendingBalance() {
        return _getPendingBalance.apply(this, arguments);
      }
      return getPendingBalance;
    }()
  }, {
    key: "fetchBalance",
    value: function () {
      var _fetchBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var slips, total, _iterator2, _step2, s, _ref2, _s$amount, _s$slip, raw;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              // Sum all unreserved slips for this NFT id
              slips = this._returnNFTSlips({
                unreserved: true
              });
              total = BigInt(0);
              _iterator2 = _createForOfIteratorHelper(slips);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  s = _step2.value;
                  try {
                    raw = (_ref2 = (_s$amount = s === null || s === void 0 ? void 0 : s.amount) !== null && _s$amount !== void 0 ? _s$amount : s === null || s === void 0 || (_s$slip = s.slip1) === null || _s$slip === void 0 ? void 0 : _s$slip.amount) !== null && _ref2 !== void 0 ? _ref2 : 0;
                    total += BigInt(typeof raw === 'bigint' ? raw : String(raw));
                  } catch (err) {}
                }

                // CryptoModule expects a string
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              this.balance = total.toString();
              return _context9.a(2, this.balance);
          }
        }, _callee9, this);
      }));
      function fetchBalance() {
        return _fetchBalance.apply(this, arguments);
      }
      return fetchBalance;
    }()
  }, {
    key: "returnAddress",
    value: function returnAddress() {
      // NFTs are sent to public keys, not external addresses
      return this.app.wallet.publicKey;
    }
  }, {
    key: "formatAddress",
    value: function formatAddress() {
      return this.returnAddress();
    }
  }, {
    key: "returnPrivateKey",
    value: function returnPrivateKey() {
      // NFTs are controlled by the wallet key
      return this.app.wallet.returnPrivateKey();
    }
  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var amount,
          recipient,
          unique_hash,
          amountInt,
          tx_msg,
          newtx,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              amount = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : '';
              recipient = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : '';
              unique_hash = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : '';
              if (!(!amount || BigInt(amount) <= 0n)) {
                _context0.n = 1;
                break;
              }
              throw new Error('NFTCryptoModule: invalid amount');
            case 1:
              // Defensive recipient handling
              if (!recipient || typeof recipient !== 'string') {
                recipient = this.app.wallet.publicKey;
              } else {
                recipient = recipient.trim();

                // If wallet has validation function, use it safely
                if (this.app.crypto.isPublicKey && typeof this.app.crypto.isPublicKey === 'function') {
                  if (!this.app.crypto.isPublicKey(recipient)) {
                    recipient = this.app.wallet.publicKey;
                  }
                } else {
                  // Fallback heuristic: require reasonable length
                  if (recipient.length < 20) {
                    recipient = this.app.wallet.publicKey;
                  }
                }
              }
              amountInt = Number.parseInt(String(amount), 10);
              if (!(!Number.isInteger(amountInt) || amountInt <= 0)) {
                _context0.n = 2;
                break;
              }
              throw new Error('NFTCryptoModule: invalid amount');
            case 2:
              tx_msg = JSON.parse(JSON.stringify(this.nft.txmsg || {}));
              _context0.n = 3;
              return this.app.wallet.createNFTTransaction(this.nft, recipient, amountInt, BigInt(0), BigInt(0), tx_msg);
            case 3:
              newtx = _context0.v;
              if (newtx) {
                _context0.n = 4;
                break;
              }
              throw new Error('NFTCryptoModule: unable to construct NFT transfer');
            case 4:
              _context0.n = 5;
              return this.nft.modifyBeforeSend(newtx, recipient);
            case 5:
              newtx = _context0.v;
              if (newtx) {
                _context0.n = 6;
                break;
              }
              throw new Error('NFTCryptoModule: transfer blocked by module.');
            case 6:
              _context0.n = 7;
              return newtx.sign();
            case 7:
              _context0.n = 8;
              return this.app.network.propagateTransaction(newtx);
            case 8:
              return _context0.a(2, unique_hash || newtx.signature);
          }
        }, _callee0, this);
      }));
      function sendPayment() {
        return _sendPayment.apply(this, arguments);
      }
      return sendPayment;
    }() //
    // Legacy CryptoModule "crypto payment" channel (Saito notification txs for web3).
    // NFT liquidity uses bound/NFT txs only; these stubs avoid accidental handling.
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(blk, tx, conf) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              return _context1.a(2, 0);
          }
        }, _callee1);
      }));
      function onConfirmation(_x4, _x5, _x6) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "sendPaymentTransaction",
    value: function () {
      var _sendPaymentTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(publicKey, from_address, to_address, amount, hash) {
        var memo,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              memo = _args10.length > 5 && _args10[5] !== undefined ? _args10[5] : '';
            case 1:
              return _context10.a(2);
          }
        }, _callee10);
      }));
      function sendPaymentTransaction(_x7, _x8, _x9, _x0, _x1) {
        return _sendPaymentTransaction.apply(this, arguments);
      }
      return sendPaymentTransaction;
    }()
  }, {
    key: "onReceivePayment",
    value: function onReceivePayment(tx) {}

    /********************************************************
     * OPTIONAL / OVERRIDDEN BEHAVIOR
     ********************************************************/
  }, {
    key: "fetchHistory",
    value: function () {
      var _fetchHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var ts,
          callback,
          _args11 = arguments;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              ts = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : null;
              callback = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : null;
              // Explicitly unsupported for NFTs
              if (callback) {
                callback([]);
              }
            case 1:
              return _context11.a(2);
          }
        }, _callee11);
      }));
      function fetchHistory() {
        return _fetchHistory.apply(this, arguments);
      }
      return fetchHistory;
    }()
  }, {
    key: "fetchPendingDeposits",
    value: function () {
      var _fetchPendingDeposits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var callback,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              callback = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : null;
              if (callback) {
                callback([]);
              }
              return _context12.a(2, []);
          }
        }, _callee12);
      }));
      function fetchPendingDeposits() {
        return _fetchPendingDeposits.apply(this, arguments);
      }
      return fetchPendingDeposits;
    }()
  }, {
    key: "validateAddress",
    value: function validateAddress(address) {
      return this.app.crypto.isPublicKey(address);
    }
  }, {
    key: "returnUtxo",
    value: function () {
      var _returnUtxo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var state,
          limit,
          order,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              state = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : 'unspent';
              limit = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 1000;
              order = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : 'DESC';
              return _context13.a(2, this._returnNFTSlips({
                state: state,
                limit: limit
              }));
          }
        }, _callee13, this);
      }));
      function returnUtxo() {
        return _returnUtxo.apply(this, arguments);
      }
      return returnUtxo;
    }()
  }]);
}(CryptoModule);
module.exports = NFTCryptoModule;